module.exports = __webpack_public_path__ + "static/028.thumb-452484008678c1ff4c3d1340017a5d54.jpg";